<div class="prf-information-for-different-users-card" [ngClass]="card.theme">
  <prf-h3 class="prf-information-for-different-users-card-title">{{ card.title }}</prf-h3>
  <p class="prf-information-for-different-users-card-description">{{ card.description }}</p>
  <a class="prf-information-for-different-users-card-link" [routerLink]="card.loginLink.href" (click)="onClickUserCard(card.loginLink.ymGoal)">{{ card.loginLink.linkText }}</a>
  <prf-image class="prf-information-for-different-users-card-image" [image]="card.image" />
</div>
